import axios from 'axios';
import api from '../base';

export function getCargoAssigners() {
    return axios({
        method: 'get',
        url: '/api/v1/cargoassigner',
        withCredentials: true,
    })// todo sending response.data
        .then(response => response.data)
        .catch(response => response.data);
}

/**
 * 
 * @param {string[]} realCargoIds 
 * @returns 
 */
export function getCargoAssignersPost(realCargoIds) {
    return axios({
        method: 'post',
        url: '/api/v2/cargoassigner',
        withCredentials: true,
        data: {
            realCargoIds,
        },
    })// todo sending response.data
        .then(response => response.data)
        .catch(response => response.data);
}

/**
 * @param {{ page: number, limit: number, filters?: { search?: string, details?: number } }} param0
 */
export function getCargoGazetters({
    page, limit, filters = {},
}) {
    return axios({
        method: 'post',
        url: '/api/v2/adminPanel/gazetters',
        withCredentials: true,
        data: {
            page, limit, filters,
        },
    })
        .then(response => response.data)
        .catch(response => response.data);
}

export function deleteCargoGazetter(id) {
    return axios({
        method: 'delete',
        url: `/api/v2/adminPanel/gazetters/${id}`,
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.data);
}

export function updateCargoAssigner(item) {
    return axios({
        method: 'POST',
        url: `/api/v1/cargoassigner/cargo/${item._id}`,
        withCredentials: true,
        data: {
            CargoCategory: item.CargoCategory,
            CargoCategoryName: item.CargoCategoryName,
            realCargoName: item.realCargoName,
            realCargoId: item.realCargoId,
            details: item.details,
        },
    }) // todo sending response.data
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function getOneCargoByRealCargoId(id) {
    return axios({
        method: 'GET',
        url: `/api/v1/cargoassigner/cargo/${id}`,
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.data);
}

async function fetchSearatesCategories() {
    return await api.call('cargoassigner/searates-categories');
}

async function updateAdditionalInfo(id, data) {
    return await api.call(`cargoassigner/${id}/additional-info`, data, 'post');
}

export async function updateRealAdditionalInfo(id, data) {
    return await api.call(`cargoassigner/${id}/additional-info`, data, 'post');
}

async function getOne(id) {
    return await api.call(`cargoassigner/${id}`);
}

export async function getRealCargoNameWithGaz(id) {
    return axios({
        method: 'GET',
        url: `/api/v2/adminPanel/realCargoName/${id}`,
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.data);
}

export default {
    fetchSearatesCategories,
    updateAdditionalInfo,
    updateRealAdditionalInfo,
    getOne,
    getRealCargoNameWithGaz,
};




// WEBPACK FOOTER //
// ./app/services/cargoes/assigners.js